var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isReloading)?_c('div',{attrs:{"id":"app"},on:{"click":_vm.checkTimer}},[(_vm.isRouterRefresh)?_c('router-view'):_vm._e(),_c('ku-message-box',{attrs:{"type":"info","text":_vm.$t('温馨提示'),"tip":_vm.needReloadTime ? _vm.$t('当前页面长时间未操作，请点击确定刷新页面，倒计时内无操作则自动刷新') : _vm.$t('当前页面长时间未操作，请点击确定刷新页面'),"visible":_vm.visible,"confirm-btn-cfg":{
      text: _vm.$t('刷新'),
      countdown: _vm.needReloadTime && _vm.autoReloadTime,
      autoClick: _vm.needReloadTime,
      disableWhenCount: false
    },"is-ads":false,"need-close":false},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.onConfirm}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }